import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { GameModel } from "../GameModel";

export class DevelopmentLayer extends Phaser.Group {

    constructor(game: Phaser.Game) {

        super(game, null, "development-layer");
        
        const backgroundSprite = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData("lila-square"));
        backgroundSprite.scale.setTo(GameConstants.GAME_WIDTH / 16, GameConstants.GAME_HEIGHT / 16);
        backgroundSprite.alpha = .85;
        this.add(backgroundSprite);
        
        const backButton = new Phaser.Button(this.game, 75, 30, "texture_atlas_0", this.onClickBack, this);
        backButton.setFrames("back_button_on.png", "back_button_off.png", "back_button_on.png");
        backButton.anchor.setTo(.5, .5);
        backButton.scale.x = GameVars.scaleX;
        this.add(backButton);
                
        const winButton = new Phaser.Button(this.game, GameConstants.GAME_WIDTH / 2, 100, "texture_atlas_0", this.onClickWin, this);
        winButton.setFrames("button_win_on.png", "button_win_off.png", "button_win_on.png");
        winButton.anchor.setTo(.5, .5);
        winButton.scale.x = GameVars.scaleX;
        this.add(winButton);
        
        const loseButton = new Phaser.Button(this.game, GameConstants.GAME_WIDTH / 2, 140, "texture_atlas_0", this.onClickLose, this);
        loseButton.setFrames("button_lose_on.png", "button_lose_off.png", "button_lose_on.png");
        loseButton.anchor.setTo(.5, .5);
        loseButton.scale.x = GameVars.scaleX;
        this.add(loseButton);
        
        const startedGameLabel = new Phaser.BitmapText(this.game,  GameConstants.GAME_WIDTH / 2, 250, "marker-felt", "simulate an started game", 20);
        startedGameLabel.x -= startedGameLabel.width / 2;
        this.add(startedGameLabel);
        
        const okStartedGameButton = new Phaser.Button(this.game, GameConstants.GAME_WIDTH / 2, 300, "texture_atlas_1", this.onClickStartedGame, this);
        okStartedGameButton.setFrames("button-ok-on.png", "button-ok-off.png", "button-ok-on.png");
        okStartedGameButton.anchor.setTo(.5, .5);
        okStartedGameButton.scale.x = GameVars.scaleX;
        this.add(okStartedGameButton);

        const almostFinishedGameLabel = new Phaser.BitmapText(this.game, GameConstants.GAME_WIDTH / 2, 350, "marker-felt", "simulate an almost finished game", 20);
        almostFinishedGameLabel.x -= almostFinishedGameLabel.width / 2;
        this.add(almostFinishedGameLabel);
        
        const okAlmostFinishedGame = new Phaser.Button(this.game, GameConstants.GAME_WIDTH / 2, 400, "texture_atlas_1", this.onClickAlmostFinishedGame, this);
        okAlmostFinishedGame.setFrames("button-ok-on.png", "button-ok-off.png", "button-ok-on.png");
        okAlmostFinishedGame.anchor.setTo(.5, .5);
        okAlmostFinishedGame.scale.x = GameVars.scaleX;
        this.add(okAlmostFinishedGame);
    }
    
    private onClickBack(b: Phaser.Button): void {
        
        b.clearFrames();
        
        GameModel.currentInstance.closeDevelopmentLayer();
    }
    
    private onClickWin(b: Phaser.Button): void {
                    
        b.clearFrames();
                    
        GameModel.currentInstance.onGameWon();
    }
    
    private onClickLose(b: Phaser.Button): void {

        b.clearFrames();
        
        GameModel.currentInstance.onGameLost();
    }
    
    private onClickStartedGame(b: Phaser.Button): void {
            
        b.clearFrames();
        
        GameVars.getInstance().simulatesStartedGame = true;
        GameVars.getInstance().aboutToFinish = false;
        
        this.game.state.start("GameState", true, false);
    }
    
    private onClickAlmostFinishedGame(b: Phaser.Button): void {
        
        b.clearFrames();
        
        GameVars.getInstance().simulatesStartedGame = true;
        GameVars.getInstance().aboutToFinish = true;
        
        this.game.state.start("GameState", true, false);
    }
}
